<template>
  <div
    class="frequency-selector"
    role="radiogroup"
    :aria-label="ariaLabel"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="frequency-option text-body-2"
      :class="{ 'frequency-option-selected': modelValue === option.value }"
      role="radio"
      :aria-checked="modelValue === option.value"
      @click="handleSelect(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: 'none',
    validator: (value) => ['none', 'weekly', 'monthly'].includes(value),
  },
  ariaLabel: {
    type: String,
    default: 'Frequency',
  },
});

const emit = defineEmits(['update:modelValue']);

const options = [
  { value: 'none', label: 'None' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

const handleSelect = (value) => {
  if (value === props.modelValue) {
    return;
  }

  emit('update:modelValue', value);
};
</script>

<style scoped lang="less">
.frequency-selector {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border: 1px solid @stroke-default;
  border-radius: 10px;
  background: @white;
}

.frequency-option {
  margin: 0;
  padding: 4px 12px;
  min-width: 71px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: @text-dark;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  cursor: pointer;
}

.frequency-option-selected {
  background: @text-darkest;
  color: @white;
}
</style>
